import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductFullViewController } from '../controllers/ProductFullViewController';
import { IProductInfoPopupPayload } from '../constants/ProductInfoPopupFieldType';

export class ProductInfoPopupLoadedUseCase {
    private productFullViewController: ProductFullViewController;
    private payload: IProductInfoPopupPayload;

    constructor(payload: IProductInfoPopupPayload) {
        this.productFullViewController = diContainer.get(serviceNames.productFullViewController);
        this.payload = payload;
    }

    public execute = async () => {
        this.productFullViewController.setProductInfoPopupConfig(this.payload);
    };
}
